// Pone el isotipo del brandbook arriba del "mykora." grande del pie y lo anima cuando entra en pantalla (ver isotipo.css).
(() => {
  // páginas con el "mykora." grande: arriba de la palabra · páginas sin él (Club): al principio del pie
  const wm = document.querySelector('.wordmark'), ft = document.querySelector('footer');
  if (!wm && !ft) return;
  const box = document.createElement('div'); box.className = 'marca-fin' + (wm ? '' : ' sola');
  box.innerHTML = '<span class="iso espera" aria-hidden="true"><i class="iso-anillo"></i><span class="iso-giro"><i class="iso-lam"></i></span></span>';
  if (wm) wm.before(box); else ft.prepend(box);
  const iso = box.firstElementChild;
  const abrir = () => { iso.classList.remove('espera'); iso.classList.add('abre'); };
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return abrir();
  const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { io.disconnect(); abrir(); } }, { threshold: .4 });
  io.observe(iso);
})();
